import { gql } from '@apollo/client';
import Fragments from './fragments';

export const APPROVAL_TYPE_UPDATED = gql`
  subscription approvalTypeUpdated {
    approvalTypeUpdated {
      approvalType {
        ...approvalTypeItem
        approvalTypeDecisionReasons {
          ...approvalTypeDecisionReasonItem
        }
      }
    }
  }
  ${Fragments.approvalTypeItem}
  ${Fragments.approvalTypeDecisionReasonItem}
`;

export const APPROVAL_TYPE_LEVEL_DELETED = gql`
  subscription approvalTypeLevelDeleted {
    approvalTypeLevelDeleted {
      approvalTypeId
      approvalTypeLevelId
    }
  }
`;
